export default function places() {
  return [
    'placeGrid',
    'placeDetails',
    'placeCards',
    'placeFeed',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/places.js